'use client';
import { memo, useEffect, useState } from 'react';

import CustomCamera from '0_canvas/CustomCamera/CustomCamera';
import TilesScene from '0_canvas/Scenes/TilesScene/TilesScene';
import Sky from '0_canvas/Sky/Sky';
import { useResponseStore } from 'state/responseStore';
import { publicAssets } from 'utils/gcs';

import WeatherScreenScene from '../WeatherScreenSceene/WeatherScreenScene';

const MainScene = () => {
  const [weatherScreenTextureUrl, setWeatherScreenTextureUrl] = useState('');
  const response = useResponseStore(s => s.response);

  useEffect(() => {
    setWeatherScreenTextureUrl(
      response?.streetview?.imageUrl || publicAssets('/effects/house.jpeg')
    );
  }, [response]);

  return (
    <>
      <TilesScene />
      <CustomCamera />
      <Sky />
      {weatherScreenTextureUrl && (
        <WeatherScreenScene textureUrl={weatherScreenTextureUrl} />
      )}
    </>
  );
};

export default memo(MainScene);
